import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import Profile from './views/Profile.vue'
// import ChatPage from './views/ChatPage.vue'
import Login from './views/Login.vue'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/Login'
    },
    {
      path: '/home',
      name: 'home',
      components: {
        default: Home
      },
      props: true
    },
    {
      path: '/contact',
      name: 'contact',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
      component: () => import( /* webpackChunkName: "default" */  './views/Contact.vue')
      // components: {
      //   default: Contact
      // }
    },
    {
      path: '/profile/:uid',
      name: 'profile',
      component: () => import( /* webpackChunkName: "default" */  './views/Profile.vue')
      // components: {
      //   default: Profile
      // }
    },
    {
      path: '/ChatPage/:cid',
      name: 'chatPage',
      component: () => import( /* webpackChunkName: "default" */  './views/ChatPage.vue')
      // components: {
      //   default: ChatPage
      // }
    },
    {
      path: '/Login',
      name: 'login',
      components: {
        default: Login
      }
    },
    {
      path: '/searchPage',
      name: 'searchPage',
      component: () => import( /* webpackChunkName: "default" */  './views/searchPage.vue')
      // components: {
      //   default: ChatPage
      // }
    }
  ]
})
